import React from 'react';
import { getCardDisplayName, getCardColor } from '../utils/cardUtils';
import { calculateCardValue, getSpecialEffect } from '../utils/gameLogic';
import { useTranslation } from '../i18n/index.jsx';
import './Card.css';

const Card = ({
  card,
  isSelected,
  isPlayable,
  onClick,
  style,
  currentSum = 0
}) => {
  const cardValue = calculateCardValue(card, currentSum);
  const specialEffect = getSpecialEffect(card);
  const cardColor = getCardColor(card.suit);
  const { t } = useTranslation();

  const getSuitSymbol = (suit) => {
    const symbols = {
      hearts: '♥',
      diamonds: '♦',
      clubs: '♣',
      spades: '♠'
    };
    return symbols[suit];
  };

  const getEffectLabel = () => {
    if (specialEffect === 'skip') return t('ruleSkip');
    if (specialEffect === 'reverse') return t('ruleReverse');
    if (card.value === 'K') return '= 99';
    if (card.value === 'A') return '+1/+11';
    const v = cardValue;
    return `${v >= 0 ? '+' : ''}${v}`;
  };

  const getSpecialClass = () => {
    if (specialEffect === 'skip') return 'special-skip';
    if (specialEffect === 'reverse') return 'special-reverse';
    if (card.value === '10') return 'special-minus';
    return '';
  };

  return (
    <div
      className={`card ${isSelected ? 'selected' : ''} ${isPlayable ? 'playable' : 'disabled'} ${cardColor} ${getSpecialClass()}`}
      onClick={onClick}
      style={style}
    >
      <div className="card-inner">
        <div className="card-header">
          <span className="card-value">{card.value}</span>
          <span className="card-suit">{getSuitSymbol(card.suit)}</span>
        </div>

        <div className="card-center">
          <div className="card-suit-large">{getSuitSymbol(card.suit)}</div>
        </div>

        <div className="card-footer">
          <span className="card-value">{card.value}</span>
          <span className="card-suit">{getSuitSymbol(card.suit)}</span>
        </div>

        {isPlayable && (
          <span className="card-effect">{getEffectLabel()}</span>
        )}
      </div>

      {isSelected && (
        <div className="selection-indicator"></div>
      )}
    </div>
  );
};

export default Card;
